import { daysByIndex, seoDays } from 'features/store-common-info/store-schedule/utils';
import { StoreDetail } from 'features/store';

const SEPARATOR = ', ';
const BASE_KEY = 'operationalTime';

const getCommonWorkingHours = (storeDetail: StoreDetail, excludeDays: string[]) => {
  let result = '';

  const commonWorkingHours = getWorkingHourProperty(storeDetail, BASE_KEY);
  if (commonWorkingHours) {
    for (let day of seoDays) {
      if (excludeDays.indexOf(day) === -1) {
        result += day + ',';
      }
    }

    result = result.substring(0, result.length - 1);
    result += ' ' + commonWorkingHours;
  }

  return result;
};

const getDaysWorkingHours = (storeDetail: StoreDetail) => {
  const excludeDays = [];
  const workingSeparateDays = [];

  for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
    const weekday = daysByIndex[dayIndex];
    const dayKey = `${BASE_KEY}${weekday}`;

    const dayWorkingHours = getWorkingHourProperty(storeDetail, dayKey);
    if (dayWorkingHours) {
      excludeDays.push(seoDays[dayIndex]);
      workingSeparateDays.push(seoDays[dayIndex] + ' ' + dayWorkingHours);
    }
  }

  return [workingSeparateDays.join(SEPARATOR), excludeDays] as [string, string[]];
};

const getWorkingHourProperty = (store: StoreDetail, key: string) => {
  return store[key as keyof StoreDetail] as string | undefined;
};

export const getWorkingHours = (storeDetail: StoreDetail) => {
  const [workingSeparateDays, excludeDays] = getDaysWorkingHours(storeDetail);
  const commonWorkingHours = getCommonWorkingHours(storeDetail, excludeDays);

  if (workingSeparateDays === '') {
    return commonWorkingHours;
  } else if (commonWorkingHours === '') {
    return workingSeparateDays;
  }

  return commonWorkingHours + SEPARATOR + workingSeparateDays;
};
